module.exports = __webpack_public_path__ + "img/4step-image3.324a79c7.png";